// import tinycolor from 'tinycolor2';
import { creatorReducer } from './station';

export const RECEIVE_STATIONS = 'RECEIVE_STATIONS';

const emptyArray = [];
const emptyObject = {};

const initialState = {
  stations: emptyArray,
  categoriesDictionary: emptyObject,
  centerSortedStations: emptyArray,
};

// reducers

function stationReducer(state = emptyObject, action) {
  switch (action.type) {
    case RECEIVE_STATIONS: {
      const { creator } = state;
      return {
        ...state,
        creator: creatorReducer(creator, action),
      };
    }
    default:
      return state;
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_STATIONS: {
      const { stations } = action;
      const processedStations = stations.map(s => stationReducer(s, action));
      return {
        ...state,
        stations: processedStations,
        centerSortedStations: centerSortStations(processedStations),
        categoriesDictionary: makeCategoriesDictionary(processedStations),
      };
    }
    default:
      return state;
  }
}

// action creators

export function receiveStations(stations) {
  return {
    type: RECEIVE_STATIONS,
    stations,
  };
}

export function fetchStations(baseUrl = '') {
  // TODO: 'fetching' state
  return (dispatch, getState) =>
    fetch(`${baseUrl}/api/stations`)
      .then(response => response.json())
      .then(responseJson => {
        const { userDictionary } = responseJson;
        let { stations } = responseJson;
        // extend with creator info
        stations = stations.map(s => ({
          ...s,
          creator: creatorFromStation(s, userDictionary),
        }));
        dispatch(receiveStations(stations));
        return responseJson.stations;
      });
}

export function moveCarousel(direction) {
  return {
    type: '', // no actual actions
    meta: {
      analytics: {
        type: 'event-homepage-carousel',
        payload: {
          target: direction,
        },
      },
    },
  };
}

export function clickCarousel(index) {
  return {
    type: '', // no actual actions
    meta: {
      analytics: {
        type: 'event-homepage-carousel',
        payload: {
          target: 'Listen',
          value: index,
        },
      },
    },
  };
}

export function clickCategory(index) {
  return {
    type: '', // no actual actions
    meta: {
      analytics: {
        type: 'event-homepage-click',
        payload: {
          target: 'Category',
          value: index,
        },
      },
    },
  };
}

export function clickStation(index) {
  return {
    type: '', // no actual actions
    meta: {
      analytics: {
        type: 'event-playback-click',
        payload: {
          target: 'Station',
          value: index,
        },
      },
    },
  };
}

// misc

function creatorFromStation(s, userDictionary) {
  const creator = s ? { ...userDictionary[s.creatorUserId] } : {};
  creator.userId = s.creatorUserId;
  return creator;
}

// sorts stations for presentation in the carousel
// i.e. [1, 2, 3, 4, 5] => [5, 3, 1, 2, 4]
export function centerSortStations(stations) {
  const centeredStations = [];
  stations.forEach((s, index) => {
    centeredStations[index % 2 ? 'push' : 'unshift'](s);
  });
  return centeredStations;
}

// stations come in sorted by plays
export function makeCategoriesDictionary(stations) {
  const categories = {};
  stations.forEach(
    ({ category, categoryColor, categoryEmoji, categoryId, stationId }) => {
      if (!categories[categoryId]) {
        categories[categoryId] = {
          category,
          color: `#${categoryColor}`,
          categoryEmoji,
          stationId,
          // textColor: tinycolor(`#${categoryColor}`).getLuminance() > 0.4 ? '#292F36' : '#FFFFFF',
          textColor: '#292F36',
        };
      }
    }
  );
  return categories;
}
